import _ from 'lodash';
import CMSModel from '@/visa-application/models/CMSModel';
import ApplicationCenterCMSModel from './ApplicationCenterCMSModel';

export interface NavbarLinkCMSModel {
  title: string;
  link: string;
}

export interface NavbarMenuLinkCMSModel {
  title: string;
  link: string;
  items: NavbarLinkCMSModel[];
}

export default class NavbarCMSModel implements CMSModel {
  application_center: ApplicationCenterCMSModel = new ApplicationCenterCMSModel();
  menu: NavbarMenuLinkCMSModel[] = [];

  map(obj: any): any {
    this.application_center.map(_.get(obj, 'application_center'));
    this.menu = _.get(obj, 'translation[0].menu', []);
  }
}
